import React from "react";
import { Button, Tree } from "antd";

const TreeNode = Tree.TreeNode;

class Folders extends React.Component {
  onSelect = (selectedKeys, info) => {
    console.log("selected", selectedKeys, info);
  };

  onCheck = (checkedKeys, info) => {
    console.log("onCheck", checkedKeys, info);
  };

  render() {
    return (
      <div className="folders">
        <div className="folders__head">
          <Button className="folders__add">
            <img src="/img/plus.svg" alt=""/>
            <span>New folder</span>
          </Button>
        </div>
        <div className="folders__tree">
          <Tree
            checkable
            selectable={false}
            defaultExpandedKeys={["0-0"]}
            // defaultSelectedKeys={["0-0-0", "0-0-1"]}
            defaultCheckedKeys={["0-0-0", "0-0-1"]}
            onSelect={this.onSelect}
            onCheck={this.onCheck}
          >
            <TreeNode
              title={
                <span>
                  Unassigned samples{" "}
                  <span className="ant-tree-counter">24</span>
                </span>
              }
              key="0-0"
            >
              <TreeNode
                title={
                  <span>
                    All Samples <span className="ant-tree-counter">340</span>
                  </span>
                }
                key="0-0-0"
              />
              <TreeNode
                title={
                  <span>
                    Folder X <span className="ant-tree-counter">24</span>
                  </span>
                }
                key="0-0-1"
              />
              <TreeNode
                title={
                  <span>
                    Folder Y <span className="ant-tree-counter">24</span>
                  </span>
                }
                key="0-0-2"
              />
            </TreeNode>
            <TreeNode
              title={
                <span>
                  Project A <span className="ant-tree-counter">24</span>
                </span>
              }
              key="0-1"
            >
              <TreeNode
                title={
                  <span>
                    All Samples <span className="ant-tree-counter">24</span>
                  </span>
                }
                key="0-1-0"
                defaultExpandParent
              />
              <TreeNode
                title={
                  <span>
                    Folder X <span className="ant-tree-counter">24</span>
                  </span>
                }
                key="0-1-1"
              />
              <TreeNode
                title={
                  <span>
                    Folder Y <span className="ant-tree-counter">24</span>
                  </span>
                }
                key="0-1-2"
              />
            </TreeNode>
            <TreeNode
              title={
                <span>
                  Project B <span className="ant-tree-counter">24</span>
                </span>
              }
              key="0-2"
            >
              <TreeNode
                title={
                  <span>
                    All Samples <span className="ant-tree-counter">24</span>
                  </span>
                }
                key="0-2-0"
              />
              <TreeNode
                title={
                  <span>
                    Folder X <span className="ant-tree-counter">24</span>
                  </span>
                }
                key="0-2-1"
              />
              <TreeNode
                title={
                  <span>
                    Folder Y <span className="ant-tree-counter">24</span>
                  </span>
                }
                key="0-2-2"
              />
            </TreeNode>
            <TreeNode
              title={
                <span>
                  Project C <span className="ant-tree-counter">24</span>
                </span>
              }
              key="0-3"
            >
              <TreeNode
                title={
                  <span>
                    All Samples <span className="ant-tree-counter">24</span>
                  </span>
                }
                key="0-3-0"
              />
              <TreeNode
                title={
                  <span>
                    Folder X <span className="ant-tree-counter">24</span>
                  </span>
                }
                key="0-3-1"
              />
              <TreeNode
                title={
                  <span>
                    Folder Y <span className="ant-tree-counter">24</span>
                  </span>
                }
                key="0-3-2"
              />
            </TreeNode>
          </Tree>
        </div>
      </div>
    );
  }
}

export default Folders;
